import { useCallback, useState } from 'react';
import type { SchedulingRule } from 'repository/schedule/@types/SchedulingRuleModel';
import { ScheduleService } from 'services/ScheduleService';

const scheduleService = new ScheduleService();

export const useSchedulingRuleQuery = () => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<SchedulingRule[]>([]);

    const loadData = useCallback(async () => {
        setLoading(true);
        try {
            const data = await scheduleService.scheduling_rules.getAll();
            const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
            setRows(sortedData as SchedulingRule[]);
        } catch (error) {
            console.error('Error cargando reglas de horario:', error);
            setRows([]);
        } finally {
            setLoading(false);
        }
    }, []);

    return { rows, setRows, loading, setLoading, loadData };
};
